import type { Runner } from '@ps/isp-web-services-types';

import { getHandicapSelectionValue } from './getHandicapSelectionValue';

type Props = Partial<Pick<Runner, 'runnerName'>> & Parameters<typeof getHandicapSelectionValue>[0];

const getRunnerNameWithHandicap = ({ handicap, runnerName, runnerResultType }: Props): string => {
  if (typeof handicap === 'number' && handicap !== 0) {
    return `${runnerName} (${getHandicapSelectionValue({ handicap, runnerResultType })})`;
  }

  return runnerName ?? '';
};

export default getRunnerNameWithHandicap;
